import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const RootPage = lazy(() => import('../pages/root/page'));
const ExplorePage = lazy(() => import('../pages/explore/page'));
const NetworkPage = lazy(() => import('../pages/network/page'));
const MessagesPage = lazy(() => import('../pages/messages/page'));
const NotificationsPage = lazy(() => import('../pages/notifications/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const ExpertsPage = lazy(() => import('../pages/experts/page'));
const PhasesPage = lazy(() => import('../pages/phases/page'));
const AnalyticsPage = lazy(() => import('../pages/analytics/page'));
const BoostDetailPage = lazy(() => import('../pages/analytics/boost-detail/page'));
const ScheduledPage = lazy(() => import('../pages/scheduled/page'));
const UploadPage = lazy(() => import('../pages/upload/page'));
const SignUpPage = lazy(() => import('../pages/auth/signup/page'));
const SignInPage = lazy(() => import('../pages/auth/signin/page'));
const ForgotPasswordPage = lazy(() => import('../pages/auth/forgot-password/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const MentionsLegalesPage = lazy(() => import('../pages/legal/mentions-legales/page'));
const CguPage = lazy(() => import('../pages/legal/cgu/page'));
const CgvPage = lazy(() => import('../pages/legal/cgv/page'));
const CookiesPage = lazy(() => import('../pages/legal/cookies/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const AdPub01Page = lazy(() => import('../pages/ad/pub-01/page'));
const AdminMembersPage = lazy(() => import('../pages/admin/members/page'));
const BrandPage = lazy(() => import('../pages/brand/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <RootPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/explore',
    element: <ExplorePage />,
  },
  {
    path: '/network',
    element: <NetworkPage />,
  },
  {
    path: '/messages',
    element: <MessagesPage />,
  },
  {
    path: '/notifications',
    element: <NotificationsPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/experts',
    element: <ExpertsPage />,
  },
  {
    path: '/phases',
    element: <PhasesPage />,
  },
  {
    path: '/analytics',
    element: <AnalyticsPage />,
  },
  {
    path: '/analytics/boost/:id',
    element: <BoostDetailPage />,
  },
  {
    path: '/scheduled',
    element: <ScheduledPage />,
  },
  {
    path: '/upload',
    element: <UploadPage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/auth/signup',
    element: <SignUpPage />,
  },
  {
    path: '/auth/signin',
    element: <SignInPage />,
  },
  {
    path: '/auth/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/legal/mentions-legales',
    element: <MentionsLegalesPage />,
  },
  {
    path: '/legal/cgu',
    element: <CguPage />,
  },
  {
    path: '/legal/cgv',
    element: <CgvPage />,
  },
  {
    path: '/legal/cookies',
    element: <CookiesPage />,
  },
  {
    path: '/settings',
    element: <SettingsPage />,
  },
  {
    path: '/admin/members',
    element: <AdminMembersPage />,
  },
  {
    path: '/brand',
    element: <BrandPage />,
  },
  {
    path: '/ad/pub-01',
    element: <AdPub01Page />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
